import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DomainManagementTableContainer from '../domain-management/domain-management-table-container';

import {
    fetchSuggestedDomainsIfNeeded,
    fetchSuggestedDomainsOrgDomainsIfNeeded
} from '../../common/actions/suggested-domains-action-creators';

import {
    suggestedDomainsIsLoadingSelector,
    suggestedDomainsTotalItemSelector,
    suggestedDomainsOrgDomainsSelector
} from '../../common/selectors/suggested-domains-selectors';
import { discoveredSubdomainsTableDataSelector } from './discovered-domains-selectors';

import {
    domainNameColumn,
    dmarcStatusPolicyColumn,
    totalVolumeColumn
} from '../constants/column-definitions';
import {
    DOMAIN_MANAGEMENT_TABLE_TYPE_DISCOVERED,
    DOMAIN_HIERARCHY_SUBDOMAIN
} from '../../common/constants/definitions';

/* Table columns are determined by `field`, but we specify `colId` to use as the order_by query param on sort or filter */
const columnDefs = [
    domainNameColumn,
    totalVolumeColumn,
    dmarcStatusPolicyColumn
];

export class DiscoveredSubdomainsTableContainer extends Component{

    componentDidMount(){
        const { fetchSuggestedDomainsIfNeeded, fetchSuggestedDomainsOrgDomainsIfNeeded } = this.props;

        fetchSuggestedDomainsIfNeeded();
        fetchSuggestedDomainsOrgDomainsIfNeeded();
    }

    formatOrgDomainSelectData = ( selectData ) => {
        return selectData.map( ( domain ) => {
            return { label: domain, value: domain };
        } );
    }

    render(){
        const { data, isLoading, totalItemCount, orgDomainsOfSuggestedDomains } = this.props;
        const orgDomainSelectData = this.formatOrgDomainSelectData( orgDomainsOfSuggestedDomains );

        return (
            <DomainManagementTableContainer
                columnDefs={columnDefs}
                data={data}
                isLoading={isLoading}
                orgDomainSelectData={orgDomainSelectData}
                selectedDomainFilter={DOMAIN_HIERARCHY_SUBDOMAIN}
                totalItemCount={ totalItemCount}
                type={DOMAIN_MANAGEMENT_TABLE_TYPE_DISCOVERED}
            />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        data: discoveredSubdomainsTableDataSelector( state ),
        isLoading: suggestedDomainsIsLoadingSelector( state ),
        orgDomainsOfSuggestedDomains: suggestedDomainsOrgDomainsSelector( state ),
        totalItemCount: suggestedDomainsTotalItemSelector( state ),
    };
};

const mapDispatchToProps = {
    fetchSuggestedDomainsIfNeeded,
    fetchSuggestedDomainsOrgDomainsIfNeeded
};

DiscoveredSubdomainsTableContainer.propTypes = {
    data: PropTypes.array.isRequired,
    fetchSuggestedDomainsIfNeeded: PropTypes.func.isRequired,
    fetchSuggestedDomainsOrgDomainsIfNeeded: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    orgDomainsOfSuggestedDomains: PropTypes.array.isRequired,
    totalItemCount: PropTypes.number
};

export default connect( mapStateToProps, mapDispatchToProps )( DiscoveredSubdomainsTableContainer );
